import { getUsageTracker } from '../clients/usageTracker';
import { getUsageTrackingProperties } from '../selectors/getUsageTrackingProperties';
export const setUsageTrackingProperties = store => next => action => {
  void getUsageTracker().setProperties(getUsageTrackingProperties(store.getState()));
  return next(action);
};